import { Observable } from 'rxjs';

export abstract class ProgressUsecase {
  abstract get progress$(): Observable<boolean>;

  abstract show(): string;
  abstract dismiss(id: string): void;
}
